module.exports = __webpack_public_path__ + "img/shipo-icon-trending-up.7a787cca.svg";